export enum PermissionCategory {
  userManagement = 'userManagement',
  roleManagement = 'roleManagement',
  perkManagement = 'perkManagement',
  perkApprovalManagement = 'perkApprovalManagement',
  permissionManagement = 'permissionManagement',
}

export enum PermissionsEnum {
  // Perks
  listPerks = 'listPerks',
  viewPerk = 'viewPerk',
  viewNonPublishedPerks = 'viewNonPublishedPerks',
  viewAnyPerk = 'viewAnyPerk',
  createPerk = 'createPerk',
  updatePerk = 'updatePerk',
  updateOrgUserPerk = 'updateOrgUserPerk',
  updateAnyPerk = 'updateAnyPerk',
  deletePerk = 'deletePerk',
  deleteOrgUserPerk = 'deleteOrgUserPerk',
  deleteAnyPerk = 'deleteAnyPerk',
  restorePerk = 'restorePerk',
  forceDeletePerk = 'forceDeletePerk',
  listTrashedPerks = 'listTrashedPerks',
  viewTrashedPerk = 'viewTrashedPerk',
  canAddDescriptionToPerk = 'canAddDescriptionToPerk',
  canAddImageToPerk = 'canAddImageToPerk',
  canAddLogoToPerk = 'canAddLogoToPerk',
  canAddCategoryToPerk = 'canAddCategoryToPerk',
  canAddGroupsToPerk = 'canAddGroupsToPerk',
  canAddContactToPerk = 'canAddContactToPerk',
  canAddDisplayScheduleToPerk = 'canAddDisplayScheduleToPerk',
  canAddDiscountToPerk = 'canAddDiscountToPerk',
  canAddPurchasableToPerk = 'canAddPurchasableToPerk',
  canAddLimitsAndConstraintsToPerk = 'canAddLimitsAndConstraintsToPerk',
  canAddCodesToPerk = 'canAddCodesToPerk',
  canAddInterestToPerk = 'canAddInterestToPerk',
  canAddLocationsToPerk = 'canAddLocationsToPerk',
  canPublishPerk = 'canPublishPerk',

  // Perk Approval Requests
  listPerkApprovalRequests = 'listPerkApprovalRequests',
  listAllPerkApprovalRequests = 'listAllPerkApprovalRequests',
  viewPerkApprovalRequest = 'viewPerkApprovalRequest',
  viewAnyPerkApprovalRequest = 'viewAnyPerkApprovalRequest',
  createPerkApprovalRequest = 'createPerkApprovalRequests',
  updatePerkApprovalRequest = 'updatePerkApprovalRequest',
  deletePerkApprovalRequest = 'deletePerkApprovalRequest',
  restorePerkApprovalRequest = 'restorePerkApprovalRequest',
  forceDeletePerkApprovalRequest = 'forceDeletePerkApprovalRequest',
  listTrashedPerkApprovalRequests = 'listTrashedPerkApprovalRequests',
  viewTrashedPerkApprovalRequest = 'viewTrashedPerkApprovalRequest',
  rejectPerkApprovalRequest = 'rejectPerkApprovalRequest',
  rejectAnyPerkApprovalRequest = 'rejectAnyPerkApprovalRequest',
  approvePerkApprovalRequest = 'approvePerkApprovalRequest',
  approveAnyPerkApprovalRequest = 'approveAnyPerkApprovalRequest',

  // Role
  listRoles = 'listRoles',
  viewRole = 'viewRole',
  createRole = 'createRole',
  updateRole = 'updateRole',
  deleteRole = 'deleteRole',
  restoreRole = 'restoreRole',
  forceDeleteRole = 'forceDeleteRole',
  listTrashedRole = 'listTrashedRole',
  viewTrashedRole = 'viewTrashedRole',
  canAssignRoleToUser = 'canAssignRoleToUser',
  canRemoveRoleFromUser = 'canRemoveRoleFromUser',
  canRunRoleValidatorManager = 'canRunRoleValidatorManager',
  canRunUserRoleBackgroundMigration = 'canRunUserRoleBackgroundMigration',
  canViewUserRoleBackgroundMigration = 'canViewUserRoleBackgroundMigration',
  assignPermissionsToRole = 'assignPermissionsToRole',
  removePermissionsFromRole = 'removePermissionsFromRole',

  // Permission
  listPermissions = 'listPermissions',
  viewPermission = 'viewPermission',
  createPermission = 'createPermission',
  updatePermission = 'updatePermission',
  deletePermission = 'deletePermission',
  restorePermission = 'restorePermission',
  forceDeletePermission = 'forceDeletePermission',
  listTrashedPermission = 'listTrashedPermission',
  viewTrashedPermission = 'viewTrashedPermission',
  deprecatePermission = 'deprecatePermission',
  initializePermissions = 'initializePermissions',

  /**
     * New module permission template
       listModuleNameHere = 'listModuleNameHere',
       viewModuleNameHere = 'viewModuleNameHere',
       createModuleNameHere = 'createModuleNameHere',
       updateModuleNameHere = 'updateModuleNameHere',
       deleteModuleNameHere = 'deleteModuleNameHere',
       restoreModuleNameHere = 'restoreModuleNameHere',
       forceDeleteModuleNameHere = 'forceDeleteModuleNameHere',
       listTrashedModuleNameHere = 'listTrashedModuleNameHere',
       viewTrashedModuleNameHere = 'viewTrashedModuleNameHere',
       blockModuleNameHere = 'blockModuleNameHere',
       unblockModuleNameHere = 'unblockModuleNameHere',
     */
}
